<button part="cm-button" (click)="onClick()" [class.hidden]="$hidden()" [disabled]="$loading()" [attr.aria-disabled]="$loading()" tabindex="0">
    <span part="cm-button-label" class="label"><i part="cm-button-icon" class="fas fa-file-pdf"></i>Download PDF</span>
    @if ($loading()) {
        <cm-loading-spinner-icon part="cm-button-loading-spinner"></cm-loading-spinner-icon>
    }
</button>
